import { render, staticRenderFns } from "./sso-header.vue?vue&type=template&id=0f133e9b&scoped=true"
import script from "./sso-header.vue?vue&type=script&lang=js"
export * from "./sso-header.vue?vue&type=script&lang=js"
import style0 from "./sso-header.vue?vue&type=style&index=0&id=0f133e9b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f133e9b",
  null
  
)

export default component.exports